import { useLocation } from "react-router-dom";
import IncSidebar from "@/Components/Inc/SidebarCom/IncSidebar";
import DashboardSidebar from "@/Components/Inc/SidebarCom/DashboardSidebar";
import ListMangSidebar from "@/Components/Inc/SidebarCom/ListMangSidebar";
import AgencySidebar from "@/Components/Inc/SidebarCom/AgencySidebar";
import PersonnelSidebar from "@/Components/Inc/SidebarCom/PersonnelSidebar";
import ReportSidebar from "@/Components/Inc/SidebarCom/ReportSidebar";
import SearchSidebar from "@/Components/Inc/SidebarCom/SearchSidebar";
import ConsolidationSidebar from "@/Components/Inc/SidebarCom/ConsolidationSidebar";
import PropertyRoomSideBar from "@/Components/Inc/SidebarCom/PropertyRoomSidebar";
import ExpungeSidebar from "@/Components/Inc/SidebarCom/ExpungeSidebar";
import PropertyRoomStorageSidebar from "@/Components/Inc/SidebarCom/PropertyRoomStorageSidebar";
import CaseManagementSidebar from "@/Components/Inc/SidebarCom/caseManagementSidebar";
import SealUnsealSidebar from "@/Components/Inc/SidebarCom/sealUnsealSidebar";
import PropertyRoomSidebarNew from "@/Components/Inc/SidebarCom/PropertyRoomSidebarNew";

const Sidebar = (props) => {

  // useNoBackNavigation();
  const { listManagementSideBar, agencySideBar, propertyStorageSideBar, propertyRoomSideBar, personnelSideBar, incidentSideBar, dashboardSidebar, reportSidebar, searchSidebar, consolidationSideBar, expungeSideBar, caseManagementSideBar, sealUnsealSideBar, propertyRoomSideBarNew } = props

  const useQuery = () => new URLSearchParams(useLocation().search);
  const query = useQuery();

  return (
    <>
      <div id="left-sidebar" className="sidebar ">
        <nav id="left-sidebar-nav" className="sidebar-nav">
          <div className="">
            <h5 className="brand-name text-center" >
              GoldLine{" "}
            </h5>
          </div>
          <ul className="metismenu ">
            {
              dashboardSidebar && <DashboardSidebar />
            }
            {
              incidentSideBar && <IncSidebar />
            }
            {
              caseManagementSideBar && <CaseManagementSidebar />
            }
            {
              sealUnsealSideBar && <SealUnsealSidebar />
            }
            {
              agencySideBar && <AgencySidebar />
            }
            {
              propertyRoomSideBar && <PropertyRoomSideBar />
            }
            {
              propertyRoomSideBarNew && <PropertyRoomSidebarNew />
            }
            {
              consolidationSideBar && <ConsolidationSidebar />
            }
            {
              expungeSideBar && <ExpungeSidebar />
            }
            {
              propertyStorageSideBar && <PropertyRoomStorageSidebar />
            }

            {
              personnelSideBar && <PersonnelSidebar />
            }
            {
              listManagementSideBar && <ListMangSidebar />
            }
            {
              searchSidebar && <SearchSidebar />
            }
            {
              reportSidebar && <ReportSidebar />
            }
          </ul>

        </nav>
      </div>

    </>
  );
};


export default Sidebar;
